import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import extractText from 'flarum/common/utils/extractText';
import Avatar from 'ext:ernestdefoe/parley/forum/components/Avatar';
import Icons from '../icons';
const t = (key, params) => app.translator.trans('ernestdefoe-parley-calls.forum.voice.' + key, params);

/**
 * The strip under a room's header: who is talking in its voice chat, and the
 * way in or out. Hidden when nobody is in voice and you are not either —
 * the header's button is the way in then.
 */
export default class VoiceBar extends Component {
  view() {
    const v = app.parleyVoice;
    const room = this.attrs.room;
    const inHere = v.in(room.id);
    const count = inHere ? v.session.roster.size : room.voiceCount || 0;
    if (!inHere && !count && v.joining !== room.id) return m("div", {
      className: "pl-voice-bar empty"
    });
    const people = v.rosterOf(room.id);
    const speaking = inHere ? v.session.speaking : new Set();
    return m("div", {
      className: 'pl-voice-bar' + (inHere ? ' live' : '')
    }, m("span", {
      className: "pl-voice-icon"
    }, Icons.headphones()), m("div", {
      className: "pl-voice-faces"
    }, people.slice(0, 10).map(p => m("span", {
      className: 'pl-voice-face' + (speaking.has(p.id) ? ' speaking' : '') + (p.muted ? ' muted' : ''),
      title: p.displayName
    }, Avatar(p, 26), p.muted ? m("span", {
      className: "pl-voice-muted"
    }, Icons.micoff(10)) : null))), m("span", {
      className: "pl-voice-count"
    }, t(inHere ? 'in_here' : 'count', {
      count,
      max: v.session?.cap || app.forum.attribute('parleyCalls')?.voiceCap || 10
    })), inHere ? [m("button", {
      className: 'pl-ib pl-voice-mute' + (v.session.muted ? ' on' : ''),
      "aria-pressed": String(v.session.muted),
      "aria-label": extractText(t(v.session.muted ? 'unmute' : 'mute')),
      title: extractText(t(v.session.muted ? 'unmute' : 'mute')),
      onclick: () => v.session.toggleMute()
    }, v.session.muted ? Icons.micoff(16) : Icons.mic(16)), m("button", {
      className: "pl-voice-leave",
      onclick: () => v.leave()
    }, t('leave'))] : m("button", {
      className: "pl-voice-join",
      disabled: v.joining === room.id,
      onclick: () => v.join(room)
    }, v.joining === room.id ? t('joining') : t('join')));
  }
}
flarum.reg.add('ernestdefoe-parley-calls', 'forum/components/VoiceBar', VoiceBar);